import React from "react";
import moment from "moment";

interface FormattedDateProps {
  date?: string | Date | null;
}

const FormattedDate: React.FC<FormattedDateProps> = ({ date }) => {
  return (
    <span>
      {date && moment(date).isValid()
        ? moment(date).format("DD-MMM-YYYY")
        : "-"}
    </span>
  );
};

export default FormattedDate;
